import {
  ADD_MOOD_METER_INGROUP_FIELDS_ERRORS,
  CHANGE_MOOD_METER_INGROUP_FORM_FIELD,
  CLEAR_MOOD_METER_INGROUP_FIELD_ERROR,
  InGroupActionTypes,
  RESET_MOOD_METER_INGROUP_FORM_DATA,
} from './actions'

interface FormData {
  code: string
}

interface InGroupFormState {
  data: FormData
  errors: Record<string, string | undefined>
  dirty: boolean
}

const defaultFormData = (): FormData => ({
  code: '',
})

export const initialState = (): InGroupFormState => {
  return {
    data: defaultFormData(),
    errors: {},
    dirty: false,
  }
}

export default function root(
  state: InGroupFormState = initialState(),
  action: InGroupActionTypes,
): InGroupFormState {
  switch (action.type) {
    case CHANGE_MOOD_METER_INGROUP_FORM_FIELD:
      return {
        ...state,
        data: {
          ...state.data,
          [action.payload.key]: action.payload.value,
        },
        dirty: true,
      }

    case ADD_MOOD_METER_INGROUP_FIELDS_ERRORS:
      return {
        ...state,
        errors: action.payload.errors,
      }
    case CLEAR_MOOD_METER_INGROUP_FIELD_ERROR:
      return {
        ...state,
        errors: {
          ...state.errors,
          [action.payload.field]: undefined,
        },
      }

    case RESET_MOOD_METER_INGROUP_FORM_DATA:
      return {
        ...state,
        data: defaultFormData(),
        errors: {},
        dirty: false,
      }

    default:
      return state
  }
}
